export default __webpack_public_path__ + "static/media/farming-sm.53658c00.svg";